export const ClvrPrscMaskaPositiveIntegerMask = '9'
export const ClvrPrscMaskaPositiveFloatMask = '9.9'

export const ClvrPrscMaskaPositiveNumberConfig = '9:\\d:multiple'
